import { getUserFromLocalstorage } from './localStorage';

/**
 * The logged-in user's business type tag, e.g. 'herotolk-norway'.
 * @returns {string|null} The tag, or null when there is no user or no business type.
 */
export const getBusinessTypeTag = () => {
  const user = getUserFromLocalstorage();

  if (user.businessTypes && user.businessTypes.length > 0) {
    return user.businessTypes[0].tag;
  }
  if (user?.userGroup?.businessType) {
    return user.userGroup.businessType.tag;
  }
  return null;
};

export default getBusinessTypeTag;
